exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ng-valid[required], .ng-valid.required {\n  border-left: 5px solid #42A948; }\n\n.ng-invalid {\n  border: 1px; }\n\nselect.ng-invalid {\n  border: 1px solid #a11919; }\n\ninput.ng-invalid {\n  border: 1px solid #a11919; }\n\n.btn-delete {\n  width: 10%; }\n\n.update-btn {\n  width: 10%; }\n\n.btn-cancel {\n  width: 10%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/admin/company-ae-form-add/company-ae-form-add.component.scss
// module id = ../../../../../src/app/admin/company-ae-form-add/company-ae-form-add.component.scss
// module chunks = main